<svg
    width="100%"
    height="100%"
    viewBox="0 0 862 615"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
        fill-rule: evenodd;
        clip-rule: evenodd;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 1.5;
    "
>
    <g>
        <path
            d="M859.141,2C859.141,2 517.802,278.758 447.848,325.083C356.907,385.305 198.049,317.996 170.138,241.623C152.125,192.329 179.886,57.608 309.66,54.077C412.438,51.28 479.597,121.196 481.764,191.208C486.871,356.222 2,612.897 2,612.897"
            pathlength="1"
            id="windPath"
        />
    </g>
    <path
        transform="matrix(1,0,0,1,132,132)"
        id="leaf"
        fill="currentColor"
        d="M19.025 3.587c-4.356 2.556-4.044 7.806-7.096 10.175c-2.297 1.783-5.538.88-7.412.113c0 0-1.27 1.603-2.181 3.74c-.305.717-1.644-.073-1.409-.68C3.905 9.25 14.037 5.416 14.037 5.416s-7.149-.303-11.927 5.94c-.128-1.426-.34-5.284 3.36-7.65c5.016-3.211 14.572-.715 13.555-.119"
    />
    <style>
    :root {
        --interations: 1;
    }
        #leaf {
            color: #e35336;
            stroke: #c04000;
            offset-path: url("#windPath");
            offset-distance: 50%;
            animation-name: leaf-blow;
            animation-duration: 1.5s;
            animation-iteration-count: var(--interations);
            animation-timing-function: linear;
            animation-fill-mode: forwards;
            transform: translateY(-20px) scale(3);
        }

        #windPath {
            fill: none;
            stroke-width: 10px;
            stroke: steelblue;
            stroke-dasharray: 0.1 0.9;
            stroke-dashoffset: -1;
            animation-name: dashing;
            animation-duration: 1.5s;
            animation-iteration-count: var(--interations);
            animation-timing-function: linear;
            animation-fill-mode: forwards;
        }

        @keyframes dashing {
            0% {
                stroke-dashoffset: 0.1;
            }
            90% {
                stroke-dashoffset: 1;
                stroke-dasharray: 0.1 0.9;
                stroke: linear-gradient(90deg, rgba(158, 118, 143, 0.67), rgba(159, 164, 196, 1));
            }
            99% {
                stroke-dashoffset: 1;
                stroke-dasharray: 0.001 1;
            }
            100% {
                stroke: transparent;
            }
        }
        @keyframes leaf-blow {
            0% {
                offset-distance: 80%;
            }
            40% {
                offset-distance: 55%;
            }
            50% {
                offset-distance: 50%;
            }
            60% {
                offset-distance: 45%;
            }
            85% {
                offset-distance: 0%;
                color: #e35336;
            }
            90% {
                offset-distance: 0%;
                color: transparent;
                stroke: transparent;
            }
            100% {
                offset-distance: 0%;
                color: transparent;
                stroke: transparent;
            }
        }

    </style>
</svg>
